import { useCallback } from "react";
import {
  selectAppData,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";

export const SIDE_PANES = { participants: "participants", chat: "chat" };

/** Which side pane is open ("participants", "chat" or none), in app data. */
export function useSidePane() {
  const hmsActions = useHMSActions();
  const sidePane = useHMSStore(selectAppData("sidePane")) || null;

  const setSidePane = useCallback(
    pane => hmsActions.setAppData("sidePane", pane || null),
    [hmsActions]
  );
  const toggleSidePane = useCallback(
    pane => setSidePane(sidePane === pane ? null : pane),
    [sidePane, setSidePane]
  );

  return { sidePane, setSidePane, toggleSidePane };
}
